import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonAddComponent } from '@component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from '@component/button-close-dialog/button-close-dialog.component';
import { ButtonDeleteComponent } from '@component/button-delete/button-delete.component';
import { ButtonSaveComponent } from '@component/button-save/button-save.component';
import { SelectUsuariosEmpresaComponent } from '@component/select-usuarios-empresa/select-usuarios-empresa.component';
import { StatusBadgeComponent } from '@component/status-badge/status-badge.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { Helper } from '@helpers/helper';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, TiposContacto } from '@models/base/identificadores.model';
import { ContactoDto } from '@models/contacto/contactoDto.model';
import { CreateContactoRequest } from '@models/contacto/createContactoRequest.model';
import { UpdateContactoRequest } from '@models/contacto/updateContactoRequest.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { ContactoService } from '@services/contacto/contacto.service';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoContactoService } from '@services/tipoContacto/tipoContacto.service';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { BuscarPaisGeorefComponent } from '@views/busquedas/buscar-pais-georef/buscar-pais-georef.component';
import { BuscarProvinciaLocalidadGeorefComponent } from '@views/busquedas/buscar-provincia-localidad-georef/buscar-provincia-localidad-georef.component';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dialog-form-contacto',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, MatChipsModule, MatTabsModule],
  templateUrl: './dialog-form-contacto.component.html',
  styleUrl: './dialog-form-contacto.component.css',
})
export class DialogFormContactoComponent {


  accionesDialog = AccionesDialog;
  form!: FormGroup
  public contacto: ContactoDto = new ContactoDto;
  formBuilder: FormBuilder = new FormBuilder;
  @Input() isDialog = false
  @Input() idPersona!: number
  tiposContacto!: BaseDto[];
  checkedCamposExtras = true
  get f() { return this.form.controls; }

  filteredOptions?: Observable<any[]>;

  constructor(
    private tipoContactoService: TipoContactoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogFormContactoComponent>,
    private contactoService: ContactoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,

  ) {

    this.contacto = this.data?.item || {};
    this.setForm()
  }

  ngOnInit(): void {
    this.getAllTiposContacto();
    if (this.data?.item?.id)
      this.getById(this.data?.item.id)

    if(this.data?.idPersona)
      this.form.controls['IdPersona'].setValue(this.data?.idPersona)

  }

  setForm() {
    this.form = this.formBuilder.group({
      Id: [this.contacto.id],
      ValorContacto: [this.contacto.valorContacto || null, Validators.compose([Validators.required, Validators.maxLength(100)])],
      TipoContacto: [this.contacto.tipoContacto?.id || null, Validators.compose([Validators.required,])],
      Preferido: [this.contacto.preferido || false],
      EmpresaAsociada: [this.contacto.empresaAsociada || null],
      FechaUltimoContacto: [this.contacto.fechaUltimoContacto || null],
      TipoRelacion: [this.contacto.tipoRelacion || null],
      FuenteContacto: [this.contacto.fuenteContacto || null],
      NotasSeguimiento: [this.contacto.notasSeguimiento || null],
      EstadoContacto: [this.contacto.estadoContacto || null],
      CategoriasEtiquetas: [this.contacto.categoriasEtiquetas || null],
      HistorialInteracciones: [this.contacto.historialInteracciones || null],
      PreferenciasContacto: [this.contacto.preferenciasContacto || null],
      Descripcion: [this.contacto.descripcion || null],
      Observaciones: [this.contacto.observaciones || null],
      IdPersona: [this.contacto.persona?.id || null],
    });
  }

  getById(id: number) {
    this.spinner.show("spContacto")
    this.contactoService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spContacto")
          this.contacto = data
          this.setForm()
        },
        error => {
          this.spinner.hide("spContacto")
          this.snackBar.showError(error, "Error");
        })
  }
  verCamposExtras(event: any) {
    if (event.checked == true)
      this.checkedCamposExtras = true
    else
      this.checkedCamposExtras = false
  }

   agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spContacto")
    this.contactoService.create(this.setCreateContactoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spContacto")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.persona });
        },
        error => {
          this.spinner.hide("spContacto")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spContacto")
    this.contactoService.update(this.setUpdateContactoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spContacto")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.persona });
        },
        error => {
          this.spinner.hide("spContacto")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spContacto")
    this.contactoService.delete(this.contacto?.id)
      .subscribe(
        data => {
          this.spinner.hide("spContacto")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.persona });
        },
        error => {
          this.spinner.hide("spContacto")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateContactoRequest(): CreateContactoRequest {

    const createContactoRequest = new CreateContactoRequest();

    createContactoRequest.descripcion = this.form.controls['Descripcion'].value;
    createContactoRequest.idTipoContacto = this.form.controls['TipoContacto'].value;

    if (createContactoRequest.idTipoContacto == TiposContacto.CorreoElectronico)
      if (Helper.validarCorreoElectronico(this.form.controls['ValorContacto'].value))
        createContactoRequest.valorContacto = this.form.controls['ValorContacto'].value;
      else {
        this.snackBar.showError("Formato de correo invalido.", "Error");
        throw new Error('Formato de correo invalido.');
      }

    else
      createContactoRequest.valorContacto = this.form.controls['ValorContacto'].value ?? null;

    createContactoRequest.preferido = this.form.controls['Preferido'].value ?? null;
    createContactoRequest.empresaAsociada = this.form.controls['EmpresaAsociada'].value ?? null;
    createContactoRequest.fechaUltimoContacto = this.form.controls['FechaUltimoContacto'].value ?? null;
    createContactoRequest.tipoRelacion = this.form.controls['TipoRelacion'].value ?? null;
    createContactoRequest.fuenteContacto = this.form.controls['FuenteContacto'].value ?? null;
    createContactoRequest.notasSeguimiento = this.form.controls['NotasSeguimiento'].value ?? null;
    createContactoRequest.estadoContacto = this.form.controls['EstadoContacto'].value ?? null;
    createContactoRequest.categoriasEtiquetas = this.form.controls['CategoriasEtiquetas'].value ?? null;
    createContactoRequest.historialInteracciones = this.form.controls['HistorialInteracciones'].value ?? null;
    createContactoRequest.preferenciasContacto = this.form.controls['PreferenciasContacto'].value ?? null;
    createContactoRequest.idPersona = this.form.controls['IdPersona'].value ?? null;

    return createContactoRequest
  }

  setUpdateContactoRequest(): UpdateContactoRequest {

    const updateContactoRequest = new UpdateContactoRequest();

    updateContactoRequest.descripcion = this.form.controls['Descripcion'].value ?? null;
    updateContactoRequest.idTipoContacto = this.form.controls['TipoContacto'].value ?? null;

    if (updateContactoRequest.idTipoContacto == TiposContacto.CorreoElectronico)
      if (Helper.validarCorreoElectronico(this.form.controls['ValorContacto'].value))
        updateContactoRequest.valorContacto = this.form.controls['ValorContacto'].value ?? null;
      else {
        this.snackBar.showError("Formato de correo invalido.", "Error");
        throw new Error('Formato de correo invalido.');
      }

    else
      updateContactoRequest.valorContacto = this.form.controls['ValorContacto'].value ?? null;
    updateContactoRequest.preferido = this.form.controls['Preferido'].value ?? null;
    updateContactoRequest.empresaAsociada = this.form.controls['EmpresaAsociada'].value ?? null;
    updateContactoRequest.fechaUltimoContacto = this.form.controls['FechaUltimoContacto'].value ?? null;
    updateContactoRequest.tipoRelacion = this.form.controls['TipoRelacion'].value ?? null ;
    updateContactoRequest.fuenteContacto = this.form.controls['FuenteContacto'].value ?? null;
    updateContactoRequest.notasSeguimiento = this.form.controls['NotasSeguimiento'].value ?? null;
    updateContactoRequest.estadoContacto = this.form.controls['EstadoContacto'].value ?? null;
    updateContactoRequest.categoriasEtiquetas = this.form.controls['CategoriasEtiquetas'].value ?? null;
    updateContactoRequest.historialInteracciones = this.form.controls['HistorialInteracciones'].value ?? null;
    updateContactoRequest.preferenciasContacto = this.form.controls['PreferenciasContacto'].value ?? null;
    updateContactoRequest.id = this.form.controls['Id'].value ?? null;
    updateContactoRequest.observaciones = this.form.controls['Observaciones'].value ?? null;
    updateContactoRequest.descripcion = this.form.controls['Descripcion'].value ?? null;

    return updateContactoRequest
  }

  getAllTiposContacto() {
    this.spinner.show("spTipoContacto")
    this.tipoContactoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoContacto")
          this.tiposContacto = data
        },
        error => {
          this.spinner.hide("spTipoContacto")
          this.snackBar.showError(error, "Error");
        })
  }

  onReset() {
    this.form.reset();
  }

  trackByItems(index: number, item: any): any { return item; }

  selectExpediente(expedienteSummaryDto: ExpedienteSummaryDto) {
    this.data.idExpediente = expedienteSummaryDto.id;
  }
}


